import React from "react";

function MobileSideFilter({ setSearchTerm }) {
  return (
    <div>
      <div>
        <input
          placeholder="Search"
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "100%" }}
        />
      </div>
      <div className="sub__filter__drops">
        <div>
          <div style={{ fontSize: 12 }}>Search For</div>
          <div>
            <select name="search" className="drop" id="search">
              <option value="mentors">Mentors</option>
              <option value="investors">Investors</option>
              <option value="startups">Startups</option>
              <option value="startups">APIs</option>
            </select>
          </div>
        </div>
        <div>
          <div style={{ fontSize: 12 }}>Focus Area</div>
          <div>
            <select name="focusarea" className="drop" id="focus">
              {[
                "Trading",
                "Banking",
                "Remittance",
                "Insurance",
                "Payments",
                "Wealth",
              ].map((cat, i) => (
                <option key={i} value={cat}>
                  {cat}
                </option>
              ))}
              {/* <option value="volvo">Volvo</option>
              <option value="saab">Saab</option>
              <option value="opel">Opel</option>
              <option value="audi">Audi</option> */}
            </select>
          </div>
        </div>
        <div>
          <div style={{ fontSize: 12 }}>Location</div>
          <div>
            <select name="location" className="drop" id="location">
              {["Chennai", "Mumbai", "Bangalore", "Kolkatta", "Punjab"].map(
                (place, i) => (
                  <option key={i} value={place}>
                    {place}
                  </option>
                )
              )}
              {/* <option value="saab">Saab</option>
              <option value="opel">Opel</option>
              <option value="audi">Audi</option> */}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileSideFilter;
